<div *ngIf="showInput === 'assignedTo'" class="autocomplete-line">
  <span>&#64;</span>
  <textarea
    #assignedToInput
    class="autocomplete-textarea"
    [formControl]="assignedToControl"
    [matAutocomplete]="assignedToAutocomplete"
    (keydown)="assignedToKeyPressIntercept($event)"
    placeholder="Search {{
      launchSource === 'title'
        ? '(or type @ to put @ in the title)'
        : launchSource === 'description'
        ? '(or type @ to put @ in the description)'
        : ''
    }}"
  ></textarea>
  <mat-autocomplete
    autoActiveFirstOption
    #assignedToAutocomplete="matAutocomplete"
    (optionSelected)="assignedToSelected($event)"
  >
    <mat-option
      *ngFor="let option of assignedToOptionsFiltered"
      [value]="option._id"
    >
      <mat-icon matListItemIcon *ngIf="option.selected">done</mat-icon>
      <mat-icon matListItemIcon *ngIf="!option.selected"></mat-icon>
      <div matListItemTitle>{{ option.title }}</div>
      <div matListItemLine *ngIf="option.selected">(select to remove user)</div>
    </mat-option>

    <mat-option *ngIf="assignedToOptionsFiltered.length === 0" disabled="true">
      No user found.
    </mat-option>
  </mat-autocomplete>
</div>

<div *ngIf="showInput === 'tag'" class="autocomplete-line">
  <span>#</span>
  <textarea
    #tagsInput
    class="autocomplete-textarea"
    [formControl]="tagsControl"
    [matAutocomplete]="assignedToAutocomplete"
    (keydown)="tagsKeyPressIntercept($event)"
    placeholder="Search {{
      launchSource === 'title'
        ? '(or type # to put # in the title)'
        : launchSource === 'description'
        ? '(or type # to put # in the description)'
        : ''
    }}"
  ></textarea>
  <mat-autocomplete
    autoActiveFirstOption
    #assignedToAutocomplete="matAutocomplete"
    (optionSelected)="tagsSelected($event)"
  >
    <mat-option *ngFor="let option of tagsOptionsFiltered" [value]="option._id">
      <mat-icon matListItemIcon *ngIf="option.selected">done</mat-icon>
      <mat-icon matListItemIcon *ngIf="!option.selected"></mat-icon>
      <div matListItemTitle>{{ option.title }}</div>
      <div matListItemLine *ngIf="option.selected">(select to remove tag)</div>
    </mat-option>

    <mat-option *ngIf="tagsOptionsFiltered.length === 0" disabled="true">
      Create new tag by typing its name.
    </mat-option>
  </mat-autocomplete>
</div>
